import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { PricingComponent } from '../pricing/pricing.component';
import { SharedModule } from '../shared/shared.module';
import { AboutProductComponent } from './about-product/about-product.component';
import { PricingCardsComponent } from './components/pricing-cards/pricing-cards.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { HomePriceComponent } from './home-price/home-price.component';
import { HomeComponent } from './home.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ProductFeaturesComponent } from './product-features/product-features.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'aboutProduct',
    component: AboutProductComponent
  },
  {
    path: 'productFeatures',
    component: ProductFeaturesComponent
  },
  {
    path: 'pricing',
    component: PricingComponent
  },
  {
    path: 'contactus',
    component: ContactUsComponent
  },
  {
    path: 'privacy',
    component: PrivacyComponent
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent
  }
];

@NgModule({
  declarations: [
    HomeComponent,
    AboutProductComponent,
    ProductFeaturesComponent,
    PricingComponent,
    HomePriceComponent,
    PricingCardsComponent,
    ContactUsComponent,
    TermsAndConditionsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    SlickCarouselModule
  ],
  exports: [RouterModule]
})

export class HomeModule { }
